import * as React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { resolveMediaUrl } from '../../utils/mediaUrl';

const getFileSrc = (file) => {
  if (!file) return null;
  if (typeof file === 'string') return file.trim() || null;
  if (typeof file === 'object' && typeof file.src === 'string') {
    return file.src.trim() || null;
  }
  return null;
};

const isImageSrc = (src) => /\.(jpe?g|png|gif|webp|svg|bmp)(\?|$)/i.test(src);

const MediaPreview = ({ label, file }) => {
  const rawSrc = getFileSrc(file);
  if (!rawSrc) {
    return <FieldRow label={label} value="—" />;
  }

  const href = resolveMediaUrl(rawSrc);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        gap: { xs: 0.5, sm: 2 },
        py: 1.25,
        borderBottom: '1px solid #f1f5f9',
        '&:last-child': { borderBottom: 'none' },
      }}
    >
      <Typography
        sx={{
          minWidth: { sm: 180 },
          width: { sm: 180 },
          flexShrink: 0,
          fontSize: '0.95rem',
          fontWeight: 600,
          color: '#64748b',
        }}
      >
        {label}
      </Typography>
      <Box sx={{ minWidth: 0 }}>
        {isImageSrc(href) ? (
          <Box
            component="img"
            src={href}
            alt={label}
            sx={{
              display: 'block',
              maxWidth: '100%',
              maxHeight: 220,
              borderRadius: 1,
              border: '1px solid #e2e8f0',
              objectFit: 'contain',
              backgroundColor: '#f8fafc',
            }}
          />
        ) : null}
        <Link href={href} target="_blank" rel="noopener noreferrer" underline="hover" sx={{ fontSize: '0.95rem' }}>
          {isImageSrc(href) ? 'Tam boyut' : href}
        </Link>
      </Box>
    </Box>
  );
};

const FieldRow = ({ label, value }) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: { xs: 0.5, sm: 2 },
      py: 1.25,
      borderBottom: '1px solid #f1f5f9',
      '&:last-child': { borderBottom: 'none' },
    }}
  >
    <Typography
      sx={{
        minWidth: { sm: 180 },
        width: { sm: 180 },
        flexShrink: 0,
        fontSize: '0.95rem',
        fontWeight: 600,
        color: '#64748b',
      }}
    >
      {label}
    </Typography>
    <Typography sx={{ fontSize: '1.05rem', fontWeight: 500, color: '#0F2137' }}>{value}</Typography>
  </Box>
);

export default MediaPreview;
